export const FollowModeBannerTestIds = {
  STOP_BUTTON: 'follow-mode-banner.stop-button',
};
